<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">My Shopping Cart</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/">Home</router-link>
                                    </li>
                                    <li class="breadcrumb-item active" aria-current="page">Cart</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <div class="container">
            <div class="table-responsive pt-5">
                <table class="table align-items-center table-flush">
                    <thead class="text-muted">
                    <tr>
                        <th scope="col">Product</th>
                        <th scope="col" width="120">Quantity</th>
                        <th scope="col" width="120">Price</th>
                        <th scope="col" width="200" class="text-right">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="bg-white" v-for="item in cart" :key="item.product.id">
                        <td>
                            <figure class="media">
                                <div class="img-wrap"><img :src="item.product.files[0].filePath"
                                                           class="img-thumbnail img-sm"></div>
                                <figcaption class="media-body">
                                    <h6 class="title text-truncate">{{item.product.title}}</h6>
                                    <dl v-if="item.product.quantity" class="param param-inline small">
                                        <dt>Quantity:</dt>
                                        <dd>{{item.product.quantity}}</dd>
                                    </dl>
                                    <dl class="param param-inline small">
                                        <dt></dt>
                                        <dd></dd>
                                    </dl>
                                </figcaption>
                            </figure>
                        </td>
                        <td>
                            <select v-model="item.quantity" class="form-control"
                                    @change="updateQuantity($event, item.product.id)">
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                            </select>
                        </td>
                        <td>
                            <div class="price-wrap">
                                <var class="price">Ksh {{item.quantity * item.product.price}}</var>
                                <small class="text-muted">(Ksh {{item.product.price}} each)</small>
                            </div> <!-- price-wrap .// -->
                        </td>
                        <td class="text-right">
                            <a href="" class="btn btn-sm btn-outline-danger"
                               @click.prevent="removeProductFromCart(item.product)">
                                × Remove</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <div class="row mb-5">
                    <div class="card col-md-6 p-3">
                        <div class="row col-sm-12" v-if="!discount">
                            <div class="col-sm-7">
                                <div class="form-group">
                                    <label>Have a coupon?</label>
                                    <input v-model="form_c.coupon" type="text" class="form-control"
                                           placeholder="Coupon">
                                    <small style="color: red">{{coupon_error}}</small>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <button @click="applyCoupon" type="button" id="all-btn">Apply</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <p class="text-right">
                            <b class="total">Total Cash: </b>
                            <span>Ksh: {{cartTotalPrice}}</span>
                        </p>
                        <div v-if="discount" class="col-sm-12">
                            <p class="text-right">
                                <b>Coupon: </b>
                                <span>{{coupon_info.code}}</span>
                            </p>
                            <p class="text-right">
                                <b>Discount: </b>
                                <span>Ksh: {{coupon_info.discount}}</span>
                            </p>
                            <p class="text-right">
                                <b>Sub-Total: </b>
                                <span>Ksh: {{cartTotalPrice - coupon_info.discount}}</span>
                            </p>
                        </div>
                        <div class="form-group text-right">
                            <button v-if="!$auth.check()" type="button" id="no-auth-btn" @click="logindirect">Login to checkout</button>
                            <button v-if="$auth.check()" type="button" id="all-btn" @click="checkoutModal">Proceed to
                                checkout
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="checkoutModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                 aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Checkout Details</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form>
                            <div class="modal-body">
                                <div class="form-group">
                                    <label>Phone Number</label>
                                    <input type="text" name="phone"
                                           placeholder="0712345678"
                                           class="form-control"
                                           v-model="form.phone">
                                    <small style="color: red">{{ phone_error }}</small>

                                </div>
                                <div class="form-group">
                                    <label>How do you intend to receive your shopping?</label>
                                    <div class="form-check">
                                        <input class="form-check-input" v-model="form.deliver" type="radio"
                                               value="office">
                                        <label class="form-check-label">
                                            Collect at our office
                                        </label>
                                    </div>
                                    <div class="form-check mt-2">
                                        <input class="form-check-input" v-model="form.deliver" type="radio"
                                               value="home">
                                        <label class="form-check-label">
                                            Deliver to my home
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group" v-if="form.deliver == 'home'">
                                    <label>Delivery Address</label>
                                    <VueGooglePlaces
                                            :api-key="key"
                                            types="establishment"
                                            country="ke"
                                            @placechanged="onPlaceChanged"
                                            @noresult="onNoResult">
                                        <input type="text" class="form-control" placeholder="Enter your location">
                                        <small style="color: red">{{ place_error }}</small>
                                    </VueGooglePlaces>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button type="button" @click="makeCheck()" class="btn btn-primary">Check Out</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="vld-parent">
                <loading name="loader" :active.sync="isLoading"
                         :can-cancel="false"
                         :is-full-page="fullPage">
                </loading>
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';

    export default {
        name: "Cart",
        components: {
            Loading
        },
        data() {
            return {
                coupon_error: '',
                discount: false,
                coupon_info: [],
                fullPage: true,
                phone_error: '',
                isLoading: false,
                place_error: '',
                key: "AIzaSyD_q2KJ5vODTs1xOXxn6j8gjX5ZMr-2YzY",
                place: [],
                form: {
                    county: '',
                    longitude: '',
                    latitude: '',
                    address: '',
                    name: '',
                    phone: this.$auth.user().phone,
                    deliver: '',
                    coupon_unique_id: ''
                },
                form_c: {
                    coupon: '',
                    total: this.$store.getters.cartTotalPrice
                }
            }
        },
        computed: {
            cart() {
                return this.$store.state.cart;
            },
            cartTotalPrice() {
                return this.$store.getters.cartTotalPrice;
            }
        },
        methods: {
            checkoutModal() {
                if (this.$auth.check()) {
                    $('#checkoutModal').modal('show');
                }
            },
            logindirect() {
                this.$router.push('/login')
            },
            applyCoupon() {
                if (!this.$auth.check()) {
                    this.coupon_error = "Login to apply coupon";
                } else {
                    if (!this.form_c.coupon) {
                        this.coupon_error = "The coupon field cannot be empty";
                    } else if (this.$store.state.cart.length == 0) {
                        this.$swal({
                            icon: 'error',
                            title: 'Cart is empty',
                            text: 'Cannot apply coupon'
                        });
                    } else {
                        this.isLoading = true;
                        this.coupon_error = '';
                        this.axios.post('/shopLocal/apply-coupon', this.form_c).then(response => {
                            this.isLoading = false;
                            this.discount = true;
                            this.coupon_info = response.data.data
                            this.form.coupon_unique_id = response.data.data.unique_id
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: 'Coupon applied Successfully.'
                            });
                        })
                            .catch(error => {
                                this.coupon_error = error.response.data.errors.coupon[0];
                                this.isLoading = false;
                            })
                    }
                }
            },
            makeCheck() {
                this.isLoading = true;
                if (this.$store.state.cart.length == 0) {
                    this.isLoading = false;
                    this.$swal({
                        icon: 'error',
                        title: 'Cart is empty',
                        text: 'Cannot check out'
                    });
                } else {
                    if (this.form.deliver == 'home' && !this.place.country) {
                        this.place_error = "Please enter your location";
                        return false;
                    }

                    if (this.form.phone == "") {
                        this.phone_error = "Please enter a valid phone number";
                        return false;
                    }

                    this.place_error = "";
                    this.phone_error = "";

                    this.isLoading = true;
                    this.axios.post('/shopLocal/order', {
                        total_price: this.cartTotalPrice,
                        phone: this.form.phone,
                        county: this.form.county,
                        longitude: this.form.longitude,
                        latitude: this.form.latitude,
                        address: this.form.address,
                        LocationName: this.form.name,
                        cart: this.cart,
                        deliver: this.form.deliver,
                        coupon_unique_id: this.form.coupon_unique_id
                    })
                        .then( () => {
                            this.coupon_info = [];
                            this.discount = false;
                            this.isLoading = false;
                            $('#checkoutModal').modal('hide');
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: 'Order placed Successfully. Payment process has been initiated.' +
                                    ' Please check your phone to complete payment!'
                            });
                            this.$store.dispatch('emptyCart');
                            this.form = {
                                county: '',
                                longitude: '',
                                latitude: '',
                                address: '',
                                name: '',
                                phone: '',
                                deliver: '',
                                coupon_unique_id: ''
                            }
                        })
                        .catch(() => {
                            this.$swal({
                                icon: 'error',
                                title: 'Error',
                                text: 'Check out Unsuccessful. Please try again'
                            })
                            this.isLoading = false;
                        })
                }
            },
            onNoResult() {

            },
            onPlaceChanged(e) {
                this.place = e;
                this.form.county = this.place.administrative_area_level_1;
                this.form.longitude = this.place.longitude;
                this.form.latitude = this.place.latitude;
                this.form.address = this.place.formatted_address;
                this.form.name = this.place.name;
            },
            removeProductFromCart(product) {
                this.$store.dispatch('removeProductFromCart', {
                    product: product
                });
                this.$swal({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    icon: 'error',
                    title: product.title + ' removed from cart!',
                })
            },
            updateQuantity(event, id) {
                this.$store.dispatch('updateQuantity', {
                    id: id,
                    quantity: event.target.value
                });
            }
        }
    }
</script>

<style scoped>
    .param {
        margin-bottom: 7px;
        line-height: 1.4;
    }

    .param-inline dt {
        display: inline-block;
    }

    .param dt {
        margin: 0 7px 0 0;
        font-weight: 600;
    }

    .param-inline dd {
        vertical-align: baseline;
        display: inline-block;
    }

    .cart-txt {
        font-size: 25px;
        font-weight: bold;
        color: #4CAF50;
    }

    .total {
        color: #4CAF50;
    }

    .bg {
        background-color: #ffc244;
    }

    .param dd {
        margin: 0;
        vertical-align: baseline;
    }

    .shopping-cart-wrap .price {
        color: #007bff;
        font-size: 18px;
        font-weight: bold;
        margin-right: 5px;
        display: block;
    }

    var {
        font-style: normal;
    }

    .media img {
        margin-right: 1rem;
    }

    .img-sm {
        width: 90px;
        max-height: 75px;
        object-fit: cover;
    }

    #all-btn {
        border: 1px solid #fb7e00;
        background: #fb7e00;
        color: #fff;
        border-radius: 30px;
        padding: 0 45px;
        line-height: 50px;
        text-transform: uppercase;
        font-weight: 600;
        font-size: 14px;
        margin-top: 27px;
    }

    #no-auth-btn {
        border: 1px solid #fb0000;
        background: #fb0000;
        color: #fff;
        border-radius: 30px;
        padding: 0 45px;
        line-height: 50px;
        text-transform: uppercase;
        font-weight: 600;
        font-size: 14px;
        margin-top: 27px;
    }
</style>